import {useLocation, useNavigation, useNavigationType} from '@github-ui/react-router'

import {useNavigationFocus} from '../use-navigation-focus'

export function NavigationFocusListener() {
  const location = useLocation()
  const navigationAction = useNavigationType()
  const navigation = useNavigation()

  // The first argument to useNavigationFocus is a boolean that indicates that we might be loading.
  // For example, if the location changes, but there's still XHR fetches to be made. Those remaining
  // XHR (data loaders), when they resolve, can change the shape of the page and we don't want to
  // do the navigation focus until that's settled.
  // In React Router, location does not change until the data loaders have resolved.
  // But in TanStack Router, our useLocation adapter will return the pending location early
  // for search-only navigations, before the data loaders have resolved.
  useNavigationFocus(navigation.state === 'loading', location, navigationAction)

  return null
}
